<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class=" section" v-on:click="goTo('/troubleshooting')">Incidencias</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Información</a>
  </div>
  <h1 v-if="data" class="ui header"><img class="ui image" src="../../assets/logo.png">
    <div class="content">Incidencias detalle: {{data.user}}</div>
  </h1>

  <div v-show="data" class="ui danger message"> 
    <h4 class="ui dividing header">Acciones a realizar</h4>
    <div class="ui relaxed divided list">
      <p id="idInfo"></p>
      <p id="idAction"></p>
      <p id="idDeriva"></p>
    </div>
  </div>

  <h4 v-if="data" class="ui dividing header">Datos del paquete</h4>
  <div v-if="data" class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <div class="form ui">
          <div v-if="data.apm" class="field">
            <label>Taquilla</label>
            <input type="text" v-model="data.apm" readonly>
          </div>
          <div v-if="data.status" class="field">
            <label>Estado del paquete</label>
            <input type="text" v-model="data.status" readonly>
          </div>
          <div v-if="data.in_apt_date" class="field">
            <label>Fecha introducción paquete en armario</label>
            <input type="text" v-model="data.in_apt_date" readonly>
          </div>
          <div v-if="data.lastUpdate" class="field">
            <label>Fecha ultima acción</label>
            <input type="text" v-model="data.lastUpdate" readonly>
          </div>
          <div v-if="data.sms_send_date" class="field">
            <label>Fecha SMS</label>
            <input type="text" v-model="data.sms_send_date" readonly>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="form ui">
          <div v-if="data.name" class="field">
            <label>Nombre</label>
            <input type="text" v-model="data.name" readonly>
          </div>
          <div v-if="data.phone" class="field">
            <label>Teléfono</label>
            <input type="text" v-model="data.phone" readonly>
          </div>
          <div v-if="data.email" class="field">
            <label>Email</label>
            <input type="text" v-model="data.email" readonly>
          </div>
          <div v-if="data.refcode" class="field">
            <label v-if="company === 'leroymerlin'">Código Tienda</label>
            <label v-if="company !== 'leroymerlin'">RefCode</label>
            <input type="text" v-model="data.refcode" readonly>
          </div>
          <div v-if="data.multiorder_code" class="field">
            <label>Nº Pedido</label>
            <input type="text" v-model="data.multiorder_code" readonly>
          </div>
          <div v-if="data.multiorder_code" class="field">
            <label>Bultos</label>
            <input type="text" v-model="data.bultos" readonly>
          </div>
          <div v-if="data.staff_in" class="field">
            <label>Introducido por:</label>
            <input type="text" v-model="data.staff_in" readonly>
          </div>
          <div v-if="data.staff_out" class="field">
            <label>Retirado por:</label>
            <input type="text" v-model="data.staff_out" readonly>
          </div>
        </div>
      </div>
    </div>
  </div>
  <h4 v-if="data" class="ui dividing header">Notificaciones al usuario</h4>
  <div v-if="data" class="ui stackable one column divided grid container">
    <div v-if="data.status!='PENDIENTE INTRODUCIR EN ARMARIO'" class="ui stackable one column">
      <div class="row">
        <div class="column">
          <div class="ui relaxed divided list">
            <div v-if="!data.smslist">No hay notificaciones al usuario</div>
            <div class="item" v-for="sms in data.smslist" :key="sms.id">
              <img class="ui mini image" src="../../assets/in-apt.png">
              <div class="content">
                <span class="header">{{sms.SmsStatus.created}}</span>
                <div class="description"><b>{{sms.SmsStatus.from_name}}</b></div>
              </div>
              <div class="right floated content">
                <span class="header">{{sms.SmsStatus.to_phone}}</span>
                <div class="description">{{sms.SmsStatus.status}}</div>
              </div>
            </div>
            <div v-if="data.status=='EN ARMARIO'" class="ui button green" v-on:click="resendSms(data.parcel_id,data.phone)">Re-enviar</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  actions: null,
  name: 'troubleshootingInfo',
  props: ['from', 'id'],
  data() {
    return {
      data: null,
      info: null,
      action: null,
      derivar: null,
      company: null
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role;
    this.company = JSON.parse(localStorage.company).ext;
    this.getActions()
  },
  methods: {
    getActions() {
      this.axios.get("static/actions.json").then(response => {
        this.actions = response.data[this.role];
        this.getParcelInfo();
      })
      .catch((request) => console.log('error getting actions: ' . request));
    },
    getParcelInfo() {
      hapiickApi().post('/v3/shipments/get-shipment', {
          admin_id: JSON.parse(localStorage.admin).id,
          from: this.from,
          id: this.id
        })
        .then(request => this.parcelInfo(request))
        .catch((e) => {
          console.log(e);
          console.log('error getting parcels')
      })
    },
    goTo(where) {
      this.$router.push(where)
    },
    parcelInfo(req) {
      this.data = req.data.data.parcel
      let info = ''
      if (this.data.status == "CREATE" || this.data.status == "new") {
        this.data.status = 'PENDIENTE INTRODUCIR EN ARMARIO'
        info = this.actions.CREATE
      } else if (this.data.status == "OPERIN" || this.data.status == "in-apt") {
        this.data.status = 'EN ARMARIO'
        info = this.actions.OPERIN
      } else if (this.data.status == "OPEROUT" || this.data.status == "to-term") {
        this.data.status = 'RETIRADO POR MENSAJERO'
        info = this.actions.OPEROUT
      } else if (this.data.status == "RECEIVE" || this.data.status == "delivered") {
        this.data.status = 'RECOGIDO POR DESTINATARIO'
        info = this.actions.RECEIVE
      } else {
        this.data.status = 'INDEFINIDO'
        info = this.actions.INDEFINIDO
      } 

      document.getElementById('idInfo').innerHTML = info.info
      document.getElementById('idAction').innerHTML = info.action
      document.getElementById('idDeriva').innerHTML = info.derive

      this.data.bultos = this.data.multiorder_count + '/' + this.data.total_bultos
    },
    resendSms(id, phone) {
      let provider_id = this.data.smslist[0].SmsStatus.provider_id
      hapiickApi().post('/v3/shipments/sms/resend', {
          admin_id: JSON.parse(localStorage.admin).id,
          parcel_id: id,
          provider_id: provider_id,
          phone: phone,
          from: this.data.user,
          apt_id: this.data.apt_id,
        })
        .then(request => this.getParcelInfo())
        .catch(() => console.log('error sending sms'))
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Troubleshooting/troubleshootingInfo.vue